/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons'
import intl from 'react-intl-universal'
import QRCode from 'qrcode.react'
import Countdown from '../countDown'
import './index.scss'
import { getQrcode, getQrcodeStatus, qrcodeLogin } from '@/services/login'
import { loginSuccess } from '@/utils/utils'
// import dayjs from 'dayjs'

// 二维码刷新间隔（分钟），修改此值即可更换倒计时时长
const QRCODE_REFRESH_INTERVAL_MINUTES = 10

export default function QrcodeLogin() {
  const [qrcode, setQrcode] = useState('') // 二维码id
  const [countdownKey, setCountdownKey] = useState(0) // 用于触发 Countdown 重置的 key，每次刷新时递增
  const [qrcodeStatus, setQrcodeStatus] = useState('') // 二维码扫码状态

  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)

  // 获取/刷新二维码
  const refreshQrcode = async () => {
    try {
      // const qrcodeInfo = sessionStorage.getItem('qrcode')
      // // 有缓存，且未过期，直接使用缓存二维码id
      // if (qrcodeInfo) {
      //   const { qrcodeId, time } = JSON.parse(qrcodeInfo)
      //   if (time + QRCODE_REFRESH_INTERVAL_MINUTES * 60 > dayjs().unix()) {
      //     setQrcode(qrcodeId)
      //     setCountdownKey(prev => prev + 1)
      //     return
      //   }
      // }
      const res = await getQrcode({
        oldQrcodeId: qrcode || undefined
      })
      setQrcodeStatus('')
      // sessionStorage.setItem('qrcode', JSON.stringify({
      //   qrcodeId: res.qrcodeId,
      //   time: dayjs().unix()
      // }))
      setQrcode(res.qrcodeId)
      setCountdownKey(prev => prev + 1)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    refreshQrcode()
  }, [])

  const handleQrcodeExpire = useCallback(() => {
    // sessionStorage.removeItem('qrcode')
    clearInterval(timerRef.current)
  }, [])

  // 登录
  const qrcodelogin = async (code: string) => {
    if (!code) return
    try {
      const res = await qrcodeLogin({
        authCode: code,
        qrcodeId: qrcode || undefined
      })
      if (res) {
        loginSuccess(res)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // TODO :轮询获取二维码扫码状态
  useEffect(() => {
    timerRef.current = setInterval(() => {
      if (!qrcode) return
      try {
        getQrcodeStatus({ qrcodeId: qrcode }).then(res => {
          setQrcodeStatus(res.status)
          qrcodelogin(res?.authCode)
          if (res.status === 'CONFIRMED' || res.status === 'EXPIRED' || res.status === 'CANCELLED') {
            handleQrcodeExpire()
          }
        })
      } catch (error) {
        handleQrcodeExpire()
      }
    }, 1000 * 2)
    return () => handleQrcodeExpire()
  }, [qrcode])

  return (
    <div className='loginForm-qrcode'>
      <div className='loginForm-qrcode-img'>
        <QRCode
          value={qrcode}
          size={180 * (document.documentElement.clientWidth / 1920)}
          bgColor='#ffffff'
          fgColor={'#000000'}
          level={'L'}
          renderAs={'canvas'}
        />
        {qrcodeStatus === 'SCANNED' && <div className='loginForm-qrcode-scanned-mask'>
          <CheckCircleOutlined />
          {intl.get('login.scanSuccess')}
        </div>}
        {(qrcodeStatus === 'EXPIRED' || qrcodeStatus === 'CANCELLED') && <div className='loginForm-qrcode-expired-mask' onClick={refreshQrcode}>
          <ReloadOutlined />
          {intl.get('login.qrcodeRefreshText')}
        </div>}
      </div>
      <Countdown
        key={countdownKey}
        duration={QRCODE_REFRESH_INTERVAL_MINUTES}
        onExpire={handleQrcodeExpire}
        className='loginForm-qrcode-countdown'
      />
      <div className='loginForm-qrcode-step'>
        <div className='loginForm-qrcode-step-title'>{intl.get('login.scanCodeLoginSteps')}</div>
        <div>
          <span>1</span>
          {intl.get('login.step1OpenApp')}
        </div>
        <div>
          <span>2</span>
          {intl.get('login.step2ScanQRCode')}
        </div>
        <div>
          <span>3</span>
          {intl.get('login.step3ConfirmLogin')}
        </div>
      </div>
    </div>
  )
}
